import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Divider — horizontal or vertical line separator. Pencil JiGlg.
 */
export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical'
  dashed?: boolean
}

export const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ className, orientation = 'horizontal', dashed, ...props }, ref) => (
    <div
      ref={ref}
      role="separator"
      aria-orientation={orientation}
      className={cn(
        orientation === 'horizontal' ? 'h-px w-full' : 'w-px h-full',
        dashed ? 'border-0 border-t border-dashed border-ia-border-dashed' : 'bg-ia-border',
        className,
      )}
      {...props}
    />
  ),
)
Divider.displayName = 'Divider'
